import { render, staticRenderFns } from "./QuestionnaireInfo.vue?vue&type=template&id=6c0335d8&scoped=true&"
import script from "./QuestionnaireInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireInfo.vue?vue&type=style&index=0&id=6c0335d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0335d8",
  null
  
)

export default component.exports